<template>
   <section class="checkout-area pb-70 pt-70">
      <div class="container">
         <!-- <form @submit.prevent="handleSubmit"> -->
            <div class="row">
               <div class="col-lg-6 mb-30">
                  <div class="checkbox-form">
                     <h3>Questionário do Egresso</h3>
                     <div style="border:3px solid #eaedff; border-radius:1px;  display:flex; flex-direction:column;  background:#fff;">
                        <!-- <div class="course__curriculum-content d-sm-flex justify-content-between align-items-center"
                           style="border:2px solid #f0f0f0; border-left: none; border-right: none; border-top: none;">
                           <div class="course__curriculum-info">
                              <svg class="document" viewBox="0 0 24 24">
                                 <path class="st0"
                                    d="M14,2H6C4.9,2,4,2.9,4,4v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z" />
                                 <polyline class="st0" points="14,2 14,8 20,8 " />
                                 <line class="st0" x1="16" y1="13" x2="8" y2="13" />
                                 <line class="st0" x1="16" y1="17" x2="8" y2="17" />
                                 <polyline class="st0" points="10,9 9,9 8,9 " />
                              </svg>
                              <span> <strong>Graduação:</strong> Matemática - 2022</span>
                           </div>
                           <div class="course__curriculum-meta">
                              <div style="display:inline-flex; gap:8px; align-items:center; ">
                                 <router-link to="/contact" class="e-btn e-btn-2" aria-label="Ver">Ver</router-link>
                                 <button type="button" aria-label="Excluir"
                                    style="background:none; border:none; padding:0; cursor:pointer; display:flex; align-items:center;">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                       stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                       <path d="M3 6h18" />
                                       <path d="M8 6V4h8v2" />
                                       <path d="M19 6l-1 14H6L5 6" />
                                       <path d="M10 11v6" />
                                       <path d="M14 11v6" />
                                    </svg>
                                 </button>
                              </div>
                           </div>

                        </div> -->
                        <div v-if="formSuccess" class="alert alert-success">{{ formSuccess }}</div>
                        <p v-if="loading">Carregando ...</p>
                        <p v-if="!lista.length && !loading">Nenhum questionário foi respondido até o momento.</p>
                        <div v-for="formacao in lista" :key="formacao.valor" class="course__curriculum-content d-sm-flex justify-content-between align-items-center"
                           style="border:1px solid #f0f0f0; border-left: none; border-right: none; border-top: none;">
                           <div class="course__curriculum-info">
                              <svg class="document" viewBox="0 0 24 24">
                                 <path class="st0"
                                    d="M14,2H6C4.9,2,4,2.9,4,4v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V8L14,2z" />
                                 <polyline class="st0" points="14,2 14,8 20,8 " />
                                 <line class="st0" x1="16" y1="13" x2="8" y2="13" />
                                 <line class="st0" x1="16" y1="17" x2="8" y2="17" />
                                 <polyline class="st0" points="10,9 9,9 8,9 " />
                              </svg>
                              <span> <strong>{{ formacao.tipo }}:</strong> {{ formacao.nome_curso }} - {{ formacao.ano_conclusao }}</span>
                           </div>
                           <div class="course__curriculum-meta">
                              <div style="display:inline-flex; gap:8px; align-items:center;">
                                 <button class="e-btn e-btn-2" @click="showEgressoModal = true, carregavalores(formacao), atualizar = true" aria-label="Ver">Ver</button>
                                 <button type="button" aria-label="Excluir" @click="mensagemExcluir()"
                                    style="background:none; border:none; padding:0; cursor:pointer; display:flex; align-items:center;">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                       stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                       <path d="M3 6h18" />
                                       <path d="M8 6V4h8v2" />
                                       <path d="M19 6l-1 14H6L5 6" />
                                       <path d="M10 11v6" />
                                       <path d="M14 11v6" />
                                    </svg>
                                 </button>
                              </div>
                           </div>

                        </div>
                     </div>
                     <div class="order-button-payment mt-20">
                        <button class="e-btn e-btn-border" type="button" @click="showEgressoModal = true">
                           Responder
                        </button>

                     </div>

                  </div>



               </div>
               <div class="col-lg-6">
                  <div class="checkbox-form">
                     <h3>Atualize suas informações cadastrais</h3>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="checkout-form-list" style="margin-bottom: 10px;">
                              <label>Nome Completo *</label>
                              <input type="text" v-model="form.fullName" placeholder="Meu Nome" disabled />
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="checkout-form-list" style="margin-bottom: 10px;">
                              <label>CPF *</label>
                              <input type="text" v-model="form.cpf" placeholder="000.000.000-00" disabled/>
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>Gênero <span class="required">*</span></label>
                              <select v-model="form.gender" required>
                                 <option value="">Selecione</option>
                                 <option value="Mulher Cisgênero">Mulher Cisgênero</option>
                                 <option value="Mulher Transexual">Mulher Transexual</option>
                                 <option value="Homem Cisgênero">Homem Cisgênero</option>
                                 <option value="Homem Transexual">Homem Transexual</option>
                                 <option value="Não Binário">Não Binário</option>
                                 <option value="Prefiro não responder">Prefiro não responder</option>
                                 <option value="Outro">Outro</option>
                              </select>
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="checkout-form-list" style="margin-bottom: 10px;">
                              <label>Data de nascimento *</label>
                              <input type="date" v-model="form.birthDate" required class="form-control" />
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>Nacionalidade *</label>
                              <select v-model="form.nationality" required>
                                 <option value="">Selecione</option>
                                 <option value="Brasileiro(a)">Brasileiro(a)</option>
                                 <option value="Estrangeiro">Estrangeiro</option>
                              </select>
                           </div>
                        </div>
                        <div class="col-md-6" v-if="form.nationality === 'Estrangeiro'">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>País</label>
                              <input type="text" v-model="form.country" />
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>Autoidentificação (cor/raça) *</label>
                              <select v-model="form.race" required>
                                 <option value="">Selecione</option>
                                 <option value="Preta">Preta</option>
                                 <option value="Parda">Parda</option>
                                 <option value="Amarela">Amarela</option>
                                 <option value="Indígena">Indígena</option>
                                 <option value="Branca">Branca</option>
                                 <option value="Não sei">Não sei</option>
                                 <option value="Prefiro não responder">Prefiro não responder</option>
                              </select>
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>Pessoa com deficiência? <span class="required">*</span></label>
                              <select v-model="form.disabled" required>
                                 <option value="">Selecione</option>
                                 <option value="Sim">Sim</option>
                                 <option value="Não">Não</option>
                                 <option value="Prefiro não responder">Prefiro não responder</option>
                              </select>
                           </div>
                        </div>
                        <div class="col-md-12" v-if="form.disabled === 'Sim'">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>Especificar deficiência</label>
                              <input type="text" v-model="form.disabilityDetail" />
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>Estado Civil <span class="required">*</span></label>
                              <select v-model="form.maritalStatus" required>
                                 <option value="">Selecione</option>
                                 <option value="Solteiro(a)">Solteiro(a)</option>
                                 <option value="Casado(a)">Casado(a)</option>
                                 <option value="Divorciado(a)">Divorciado(a)</option>
                                 <option value="União Estável">União Estável</option>
                              </select>
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>Estado atual de residência *</label>
                              <select v-model="form.currentState" required>
                                 <option value="">Selecione</option>
                                 <option v-for="e in estados" :key="e" :value="e">{{ e }}</option>
                              </select>
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="country-select checkout-form-list" style="margin-bottom: 10px;">
                              <label>Estado de origem *</label>
                              <select v-model="form.originState" required>
                                 <option value="">Selecione</option>
                                 <option v-for="e in estados" :key="e" :value="e">{{ e }}</option>
                              </select>
                           </div>
                        </div>
                        <div class="country-select checkout-form-list">
                              <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="checkbox" id="lgpd" value="true" v-model="lgpd" />
                                  <label class="form-check-label" for="lgpd">Autorizo expressamente que a UFDPar, doravante denominada controladora, em razão da inserção de dados necessários para o acompanhamento de egressos dos cursos de Graduação e Pós-Graduação, disponha de meus dados pessoais, profissionais e acadêmicos de acordo com o que prevê a Lei 13.709/2018 (Lei Geral de Proteção de Dados-LGPD).</label>
                              </div>
                        </div>
                        <div class="col-md-12 mt-3">
                           <button type="button" class="e-btn" @click="updateProfile">
                              Atualizar
                           </button>
                           <div v-if="profileError" class="text-danger mt-1">{{ profileError }}</div>
                           <div v-if="profileSuccess" class="text-success mt-1">{{ profileSuccess }}</div>
                        </div>
                     </div>

                  </div>
               </div>


            </div>

         <!-- </form> -->
      </div>
   </section>
   <b-modal v-model="showEgressoModal" hide-footer size="xl" scrollable :dialog-class="'modal-dialog-hero'">
      <div class="modal-custom">
         <!-- Corpo -->
         <div class="modal-body px-4 py-3">
            <div v-if="formError" class="alert alert-danger">{{ formError }}</div>
            <div v-if="formSuccess" class="alert alert-success">{{ formSuccess }}</div>

            <div class="">

               <h3>Questionário do Egresso</h3>

               <div class="payment-method">
                  <div class="accordion" id="checkoutAccordion">
                     <div class="accordion-item">
                        <h2 class="accordion-header" id="formacaoacademica">
                           <button class="accordion-button" type="button" data-bs-toggle="collapse"
                              data-bs-target="#bankOne" aria-expanded="true" aria-controls="bankOne">
                              1. Formação Acadêmica
                           </button>
                        </h2>
                        <div id="bankOne" class="accordion-collapse collapse show" aria-labelledby="formacaoacademica"
                           data-bs-parent="#checkoutAccordion">
                           <div class="accordion-body">
                              <div class="col-md-12">
                                 <div class="country-select checkout-form-list">
                                    <label>Nível de formação concluído na UFDPar? <span
                                          class="required">*</span></label>
                                    <select v-model="question.nivel" required>
                                       <option value="" disabled>Selecione</option>
                                       <option value="Graduação">Graduação</option>
                                       <option value="Especialização">Especialização</option>
                                       <option value="Residência">Residência</option>
                                       <option value="Mestrado">Mestrado</option>
                                       <option value="Doutorado">Doutorado</option>
                                       <option value="Pós-doutorado">Pós-doutorado</option>
                                    </select>
                                 </div>
                              </div>

                              <div class="col-md-12">
                                 <div class="country-select checkout-form-list">
                                    <label>Curso concluído na UFDPar? <span class="required">*</span></label>
                                    <select v-model="question.curso" required>
                                       <option value="" disabled>Selecione</option>
                                       <option v-for="c in cursosFiltrados" :key="c.nome" :value="c.nome">
                                          {{ c.nome }}
                                       </option>
                                    </select>
                                 </div>
                              </div>

                              <div class="col-md-12">
                                 <div class="country-select checkout-form-list">
                                    <label>Ano de conclusão <span class="required">*</span></label>
                                    <select v-model="question.ano" required>
                                       <option value="">Selecione um ano</option>
                                       <option v-for="a in anos" :key="a" :value="a">
                                          {{ a }}
                                       </option>
                                    </select>
                                 </div>
                              </div>

                              <div class="col-md-12" v-if="question.nivel === 'Graduação'">
                                 <div class="country-select checkout-form-list">
                                    <label>Você foi cotista?</label>
                                    <div class="form-check form-check-inline">
                                       <input class="form-check-input" type="radio" id="cotistaSim" value="Sim"
                                          v-model="question.cotista" />
                                       <label class="form-check-label" for="cotistaSim">Sim</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                       <input class="form-check-input" type="radio" id="cotistaNao" value="Não"
                                          v-model="question.cotista" />
                                       <label class="form-check-label" for="cotistaNao">Não</label>
                                    </div>
                                 </div>
                              </div>

                              <div class="col-md-12" v-if="question.cotista === 'Sim'">
                                 <div class="country-select checkout-form-list">
                                    <label>Qual sistema de cotas você utilizou? <span class="required">*</span></label>
                                    <select v-model="question.sistemaCotas" required>
                                       <option value="" disabled>Selecione</option>
                                       <option v-for="v in cotas" :key="v.valor" :value="v.valor">{{
                                          v.descricao }}</option>
                                    </select>
                                 </div>
                              </div>

                              <div class="col-md-12" v-if="question.cotista === 'Sim' && question.sistemaCotas">
                                 <div class="order-notes">
                                    <div class="checkout-form-list">
                                       <label>Comentário sobre cota (opcional)</label>
                                       <textarea id="checkout-mess" cols="30" rows="2"
                                          v-model="question.observacaoCotas" placeholder="Digite aqui..."></textarea>
                                    </div>
                                 </div>
                              </div>

                              <div class="col-md-12">
                                 <div class="country-select checkout-form-list">
                                    <label>Você foi bolsista? <span class="required">*</span></label>
                                    <div>
                                       <label class="me-2">
                                          <input type="radio" value="Sim" v-model="question.bolsista" /> Sim
                                       </label>
                                       <label>
                                          <input type="radio" value="Não" v-model="question.bolsista" /> Não
                                       </label>
                                    </div>
                                 </div>
                              </div>

                              <div class="col-md-12" v-if="question.bolsista === 'Sim'">
                                 <div class="country-select checkout-form-list">
                                    <label>Qual agência fomentadora? <span class="required">*</span></label>
                                    <div>
                                       <label v-for="a in agencias" :key="a.nome" class="d-block">
                                          <input type="radio" :value="a.nome" v-model="question.agenciaFomentadora" />
                                          {{
                                             a.nome }}
                                       </label>
                                    </div>
                                 </div>
                                 <div v-if="question.agenciaFomentadora === 'Outro'" class="checkout-form-list">
                                    <label>Especificar:</label>
                                    <input type="text" v-model="question.agenciaOutro" />
                                 </div>
                              </div>

                              <div class="col-md-12" v-if="question.nivel !== 'Graduação'">
                                 <div class="country-select checkout-form-list">
                                    <label>Qual a principal motivação para cursar pós-graduação? <span
                                          class="required">*</span></label>
                                    <div v-for="opt in motivacoesOptions" :key="opt.id">
                                       <label>
                                          <input type="checkbox" :value="opt.id" v-model="question.motivacoes" />
                                          {{ opt.descricao }}
                                       </label>
                                    </div>
                                 </div>
                              </div>

                              <div class="col-md-12" v-if="question.nivel === 'Graduação'">
                                 <div class="country-select checkout-form-list">
                                    <label>Participação em Iniciação Científica e/ou Tecnológica? *</label>
                                    <div>
                                       <label class="me-2">
                                          <input type="radio" value="Sim" v-model="question.participacaoCientifica" />
                                          Sim
                                       </label>
                                       <label>
                                          <input type="radio" value="Não" v-model="question.participacaoCientifica" />
                                          Não
                                       </label>
                                    </div>
                                 </div>
                                 <div class="country-select checkout-form-list">
                                    <label>Participou de Extensão? *</label>
                                    <div>
                                       <label class="me-2">
                                          <input type="radio" value="Sim" v-model="question.participacaoExtensao" /> Sim
                                       </label>
                                       <label>
                                          <input type="radio" value="Não" v-model="question.participacaoExtensao" /> Não
                                       </label>
                                    </div>
                                 </div>
                                 <div class="country-select checkout-form-list">
                                    <label>Participou de Ensino? *</label>
                                    <div>
                                       <label class="me-2">
                                          <input type="radio" value="Sim" v-model="question.participacaoEnsino" />
                                          Sim
                                       </label>
                                       <label>
                                          <input type="radio" value="Não" v-model="question.participacaoEnsino" />
                                          Não
                                       </label>
                                    </div>
                                 </div>
                                 <div class="country-select checkout-form-list">
                                    <label>Participou de Monitoria? *</label>
                                    <div>
                                       <label class="me-2">
                                          <input type="radio" value="Sim" v-model="question.participacaoMonitoria" />
                                          Sim
                                       </label>
                                       <label>
                                          <input type="radio" value="Não" v-model="question.participacaoMonitoria" />
                                          Não
                                       </label>
                                    </div>
                                 </div>
                              </div>
                             
                              <div class="col-md-12 mt-3">
                                 <div class="country-select checkout-form-list">
                                    <label>Analise os itens abaixo em escala de 1 (Péssimo) a 5 (Ótimo): *</label>
                                    <table class="table table-sm">
                                       <thead>
                                          <tr>
                                             <th>Itens</th>
                                             <th>1</th>
                                             <th>2</th>
                                             <th>3</th>
                                             <th>4</th>
                                             <th>5</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          <tr v-for="(item, idx) in evaluationItems" :key="idx">
                                             <td>{{ item }}</td>
                                             <td><input type="radio" :name="`ev-${idx}`" value="1"
                                                   v-model="question.evaluation[idx]" /></td>
                                             <td><input type="radio" :name="`ev-${idx}`" value="2"
                                                   v-model="question.evaluation[idx]" /></td>
                                             <td><input type="radio" :name="`ev-${idx}`" value="3"
                                                   v-model="question.evaluation[idx]" /></td>
                                             <td><input type="radio" :name="`ev-${idx}`" value="4"
                                                   v-model="question.evaluation[idx]" /></td>
                                             <td><input type="radio" :name="`ev-${idx}`" value="5"
                                                   v-model="question.evaluation[idx]" /></td>
                                          </tr>
                                       </tbody>
                                    </table>
                                 </div>
                              </div>
                              <!-- Campo de Observações -->
                              <div class="col-md-12 mt-3">
                                 <div class="checkout-form-list">
                                    <div class="order-notes">
                                       <div class="checkout-form-list">
                                          <label>Apresente observações que deseja fazer em relação ao último curso
                                             que concluiu (opcional):</label>
                                          <textarea id="checkout-mess" cols="30" rows="6" v-model="question.observacoes"
                                             maxlength="800" placeholder="Digite aqui... (até 800 palavras)"></textarea>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div class="accordion-item">
                        <h2 class="accordion-header" id="paymentTwo">
                           <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                              data-bs-target="#payment" aria-expanded="false" aria-controls="payment">
                              2. Contribuições Científicas, Profissionais e Sociais
                           </button>
                        </h2>
                        <div id="payment" class="accordion-collapse collapse" aria-labelledby="paymentTwo"
                           data-bs-parent="#checkoutAccordion">
                           <div class="accordion-body">
                              <div class="country-select checkout-form-list">
                                 <label>Após a conclusão do curso, você:*</label>
                                 <div v-for="opt in atividadesContribuicoesOptions" :key="opt.id">
                                    <label>
                                       <input type="checkbox" :value="opt.id"
                                          v-model="question.atividadesContribuicoes" />
                                       {{ opt.descricao }}
                                    </label>
                                 </div>
                              </div>

                              <div class="checkout-form-list mt-2">
                                 <label>Como você avalia a contribuição da sua pesquisa desenvolvida durante o
                                    curso no avanço do conhecimento em sua área? *</label>
                                 <div v-for="i in impacto" :key="i.valor">
                                    <label>
                                       <input type="radio" :value="i.nome" v-model="question.impactoPesquisa" />
                                       {{ i.nome }}
                                    </label>
                                 </div>
                              </div>

                              <div class="checkout-form-list mt-2">
                                 <label>O curso influenciou na melhoria dos processos de gestão e tomada de
                                    decisões em sua área? *</label>
                                 <div v-for="m in melhoria" :key="m.valor">
                                    <label>
                                       <input type="radio" :value="m.nome" v-model="question.melhoriaProcessos" />
                                       {{ m.nome }}
                                    </label>
                                 </div>
                              </div>

                              <div class="checkout-form-list mt-2">
                                 <label>Você está ou esteve envolvido na criação ou gestão de algum novo negócio
                                    ou startup após a conclusão do curso? *</label>
                                 <div>
                                    <label class="d-block">
                                       <input type="radio" value="Sim, relacionado à área do curso de pós-graduação"
                                          v-model="question.inovacaoEmpreendedorismo" />
                                       Sim, relacionado à área do curso de pós-graduação
                                    </label>
                                    <label class="d-block">
                                       <input type="radio" value="Sim, não relacionado à área do curso de pós-graduação"
                                          v-model="question.inovacaoEmpreendedorismo" />
                                       Sim, não relacionado à área do curso de pós-graduação
                                    </label>
                                    <label class="d-block">
                                       <input type="radio" value="Não" v-model="question.inovacaoEmpreendedorismo" />
                                       Não
                                    </label>
                                 </div>
                              </div>
                              <div class="order-notes"
                                 v-if="question.inovacaoEmpreendedorismo && question.inovacaoEmpreendedorismo.includes('Sim')">
                                 <div class="checkout-form-list">
                                    <label>Informar novo(s) negócio(s) ou startup(s) que está ou esteve envolvido
                                       *</label>
                                    <textarea id="checkout-mess" cols="30" rows="2" v-model="question.startupNegocios"
                                       placeholder="Digite aqui..."></textarea>
                                 </div>
                              </div>

                              <div class="checkout-form-list mt-2">
                                 <label>Desde a conclusão do curso, você esteve envolvido em atividades que
                                    promovem a responsabilidade social corporativa e sustentabilidade? *</label>
                                 <div>
                                    <label class="d-block">
                                       <input type="radio" value="Sim, em várias atividades"
                                          v-model="question.responsabilidadeSocial" />
                                       Sim, em várias atividades
                                    </label>
                                    <label class="d-block">
                                       <input type="radio" value="Sim, em algumas atividades"
                                          v-model="question.responsabilidadeSocial" />
                                       Sim, em algumas atividades
                                    </label>
                                    <label class="d-block">
                                       <input type="radio" value="Nenhuma atividade"
                                          v-model="question.responsabilidadeSocial" />
                                       Nenhuma atividade
                                    </label>
                                 </div>
                              </div>

                              <div class="order-notes"
                                 v-if="question.responsabilidadeSocial && question.responsabilidadeSocial.includes('Sim')">
                                 <div class="checkout-form-list">
                                    <label>Informar a(s) atividade(s) de responsabilidade social
                                       corporativa e sustentabilidade na qual esteve envolvido *</label>
                                    <textarea id="checkout-mess" cols="30" rows="3" v-model="question.atividadesResponsabilidade"
                                       placeholder="Digite aqui..."></textarea>
                                 </div>
                              </div>

                           </div>
                        </div>
                     </div>

                     <div class="accordion-item">
                        <h2 class="accordion-header" id="paypalThree">
                           <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                              data-bs-target="#paypal" aria-expanded="false" aria-controls="paypal">
                              3. Empregabilidade
                           </button>
                        </h2>
                        <div id="paypal" class="accordion-collapse collapse" aria-labelledby="paypalThree"
                           data-bs-parent="#checkoutAccordion">
                           <div class="accordion-body">

                              <div class="country-select checkout-form-list">
                                 <label>Você entrou no mercado de trabalho em até 12 meses após a conclusão do
                                    curso? *</label>
                                 <select v-model="question.vinculoEmpregaticio.mercado_trabalho_12_meses" required>
                                    <option value="" disabled>Selecione</option>
                                    <option>Sim</option>
                                    <option>Não</option>
                                 </select>
                              </div>
                              <div class="country-select checkout-form-list">
                                 <label>Situação atual *</label>
                                 <select v-model="question.vinculoEmpregaticio.situacao_atual" required>
                                    <option value="" disabled>Selecione</option>
                                    <option>Estou empregado na área de formação do curso concluído na UFDPar
                                    </option>
                                    <option>Estou empregado em área distinta à área de formação do curso concluído
                                       na
                                       UFDPar</option>
                                    <option>Não estou empregado</option>
                                 </select>
                              </div>
                              <div class="country-select checkout-form-list">
                                 <label>Setor de atuação *</label>
                                 <select v-model="question.vinculoEmpregaticio.setor_atuacao" required>
                                    <option value="" disabled>Selecione</option>
                                    <option v-for="s in setor" :key="s.nome">{{ s.nome }}</option>
                                 </select>
                              </div>
                              <div class="country-select checkout-form-list">
                                 <label>Jornada de Trabalho (horas semanais) *</label>
                                 <select v-model="question.vinculoEmpregaticio.jornada_trabalho" required>
                                    <option value="" disabled>Selecione</option>
                                    <option>20h</option>
                                    <option>20 - 30h</option>
                                    <option>30 - 40h</option>
                                    <option>Mais que 40h</option>
                                 </select>
                              </div>
                              <div class="country-select checkout-form-list">
                                 <label>Instituição que trabalha atualmente? *</label>
                                 <input type="text" v-model="question.vinculoEmpregaticio.instituicao_atual" required />
                              </div>
                              <div class="country-select checkout-form-list">
                                 <label>Qual a sua média mensal de rendimentos brutos? *</label>
                                 <select v-model="question.vinculoEmpregaticio.salario_medio" required>
                                    <option value="" disabled>Selecione</option>
                                    <option>até 1 salário mínimo</option>
                                    <option>entre 1 e 3 salários mínimos</option>
                                    <option>entre 4 e 7 salários mínimos</option>
                                    <option>mais que 7 salários mínimos</option>
                                 </select>
                              </div>
                              <div class="country-select checkout-form-list">
                                 <label>Qual o impacto do curso, concluído na UFDPar, na sua renda? *</label>
                                 <select v-model="question.vinculoEmpregaticio.impacto_renda" required>
                                    <option value="" disabled>Selecione</option>
                                    <option>Aumentou consideravelmente</option>
                                    <option>Aumentou um pouco</option>
                                    <option>Não houve mudança</option>
                                 </select>
                              </div>

                              <div class="country-select checkout-form-list">
                                 <label>Você concorda que o curso lhe qualificou para o mercado de trabalho?
                                    *</label>
                                 <select v-model="question.vinculoEmpregaticio.qualificacao_mercado" required>
                                    <option value="" disabled>Selecione</option>
                                    <option>Concordo totalmente</option>
                                    <option>Concordo parcialmente</option>
                                    <option>Não concordo nem discordo</option>
                                    <option>Discordo parcialmente</option>
                                    <option>Discordo totalmente</option>
                                 </select>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div class="accordion-item">
                        <h2 class="accordion-header" id="paypalThree2">
                           <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                              data-bs-target="#paypal2" aria-expanded="false" aria-controls="paypal">
                              4. Gestão ou Liderança
                           </button>
                        </h2>
                        <div id="paypal2" class="accordion-collapse collapse" aria-labelledby="paypalThree2"
                           data-bs-parent="#checkoutAccordion">
                           <div class="accordion-body">
                              <!-- Gestão / Liderança -->
                              <div class="country-select checkout-form-list">
                                 <label>Você ocupa posição de gestão ou liderança? *</label>
                                 <select v-model="question.posicao_gestao.ocupaPosicao" required>
                                    <option value="" disabled>Selecione</option>
                                    <option>Sim, em instituição pública</option>
                                    <option>Sim, em instituição privada</option>
                                    <option>Não</option>
                                 </select>
                              </div>
                              <div class="order-notes"
                                 v-if="question.posicao_gestao && question.posicao_gestao.ocupaPosicao?.startsWith('Sim')">
                                 <div class="checkout-form-list">
                                    <label>Detalhe função e instituição:</label>
                                    <textarea id="checkout-mess" cols="30" rows="2"
                                       v-model="question.posicao_gestao.detalhesPosicao"
                                       placeholder="Digite aqui..."></textarea>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <!-- Rodapé -->
         <div class="modal-footer border-top py-3 px-4 d-flex justify-content-end gap-2">

            <button v-if="!atualizar" type="button" class="e-btn" @click="submitQuestionario">Enviar</button>
            <button v-else type="button" class="e-btn" @click="submitQuestionario">Atualizar</button>
            <button type="button" class="e-btn e-btn-border" @click="showEgressoModal = false, limpavalores()">Fechar</button>
         </div>
      </div>
   </b-modal>




</template>

<script>
import keycloak from '@/keycloak';
export default {
   name: 'checkoutArea',
   data() {
      return {
         keycloak,
         backend: process.env.VUE_APP_BACKEND_URL,
         lista: [],
         lgpd: false,
         loading: false,
         error: null,
         atualizar: false,
         form: {
            fullName: '',
            cpf: '',
            gender: '',
            birthDate: '',
            nationality: '',
            country: '',
            race: '',
            disabled: '',
            disabilityDetail: '',
            maritalStatus: '',
            currentState: '',
            originState: ''
         },
         question: {
            formacaoid: 0,
            nivel: '',
            curso: '',
            ano: '',
            cotista: '',
            sistemaCotas: '',
            observacaoCotas: '',
            bolsista: '',
            agenciaFomentadora: '',
            agenciaOutro: '',
            motivacoes: [],
            participacaoCientifica: '',
            participacaoExtensao: '',
            participacaoEnsino: '',
            participacaoMonitoria: '',
            atividadesContribuicoes: [],
            observacoes: '',
            impactoPesquisa: '',
            melhoriaProcessos: '',
            inovacaoEmpreendedorismo: '',
            startupNegocios: '',
            responsabilidadeSocial: '',
            atividadesResponsabilidade: '',
            vinculoEmpregaticio: {
               mercado_trabalho_12_meses: '',
               situacao_atual: '',
               setor_atuacao: '',
               jornada_trabalho: '',
               instituicao_atual: '',
               salario_medio: '',
               impacto_renda: '',
               qualificacao_mercado: ''
            },
            posicao_gestao: {
               ocupaPosicao: '',
               detalhesPosicao: ''
            },
            evaluation: Array(12).fill('')
         },
         evaluationItems: [
            'Avaliação geral com o curso',
            'Salas de aula',
            'Bibliotecas',
            'Laboratórios de ensino',
            'Laboratórios de pesquisa',
            'Currículo do curso',
            'Professores do curso',
            'Materiais e métodos de ensino',
            'Coordenação do curso',
            'Secretaria do curso',
            'Flexibilidade de horários',
            'Espaços de convivência'
         ],
         anos: Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i),
         estados: [
            'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
         ],
         cursos: [
            { valor: 1, nivel: 1, nome: "Administração" },
            { valor: 2, nivel: 1, nome: "Biologia" },
            { valor: 3, nivel: 1, nome: "Biomedicina" },
            { valor: 4, nivel: 1, nome: "Ciências Contábeis" },
            { valor: 5, nivel: 1, nome: "Economia" },
            { valor: 6, nivel: 1, nome: "Engenharia de Pesca" },
            { valor: 7, nivel: 1, nome: "Fisioterapia" },
            { valor: 8, nivel: 1, nome: "Matemática" },
            { valor: 9, nivel: 1, nome: "Medicina" },
            { valor: 10, nivel: 1, nome: "Pedagogia" },
            { valor: 11, nivel: 1, nome: "Psicologia" },
            { valor: 12, nivel: 1, nome: "Turismo" },
            { valor: 13, nivel: 1, nome: "Outro" },
            { valor: 14, nivel: 3, nome: "Administração Pública" },
            { valor: 15, nivel: 2, nome: "Gestão de Negócios e Empreendedorismo" },
            { valor: 16, nivel: 2, nome: "Biologia Vegetal" },
            { valor: 17, nivel: 2, nome: "Especialização em Processos Estratégicos para a Gestão Escolar Pública" },
            { valor: 18, nivel: 3, nome: "Artes, Patrimônio e Museologia" },
            { valor: 19, nivel: 3, nome: "Biotecnologia" },
            { valor: 20, nivel: 3, nome: "Ciências Biomédicas" },
            { valor: 21, nivel: 4, nome: "Biotecnologia" },
            { valor: 22, nivel: 4, nome: "Ciências Biomédicas" },
            { valor: 23, nivel: 3, nome: "Psicologia" },
            { valor: 24, nivel: 3, nome: "Saúde da Família" },
            { valor: 25, nivel: 6, nome: "Programa de Residência Multiprofissional em Atenção Básica/Saúde da Família" }
         ],
         nivelCursoMap: {
            'Graduação': 1,
            'Especialização': 2,
            'Pós-graduação': 2,
            'Mestrado': 3,
            'Doutorado': 4,
            'Pós-doutorado': 3,
            'Residência': 6
         },
         cotas: [
            { valor: "L1", descricao: "Cota L1: Escola pública e renda familiar bruta mensal per capita ≤ 1,5 salário mínimo" },
            { valor: "L2", descricao: "Cota L2: Escola pública, renda ≤ 1,5 salário mínimo, autodeclarado preto, pardo ou indígena" },
            { valor: "L5", descricao: "Cota L5: Escola pública, independentemente da renda" },
            { valor: "L6", descricao: "Cota L6: Escola pública, independentemente da renda, autodeclarado preto, pardo ou indígena" },
            { valor: "L9", descricao: "Cota L9: Escola pública, renda ≤ 1,5 salário mínimo, pessoa com deficiência" },
            { valor: "L10", descricao: "Cota L10: Escola pública, renda ≤ 1,5 salário mínimo, pessoa com deficiência, autodeclarado preto, pardo ou indígena" },
            { valor: "L13", descricao: "Cota L13: Escola pública, independentemente da renda, pessoa com deficiência" },
            { valor: "L14", descricao: "Cota L14: Escola pública, independentemente da renda, pessoa com deficiência, autodeclarado preto, pardo ou indígena" }
         ],
         agencias: [
            { nome: "CNPq" },
            { nome: "CAPES" },
            { nome: "FAPEPI" },
            { nome: "UFDPar" },
            { nome: "Outro" }
         ],
         motivacoesOptions: [
            { id: 1, descricao: "Aumento salarial através da titulação" },
            { id: 2, descricao: "Possibilidade de reconhecimento e progressão profissional" },
            { id: 3, descricao: "Recomendação da instituição de vínculo de trabalho" },
            { id: 4, descricao: "Mudança de local de trabalho e ocupação" },
            { id: 5, descricao: "Interesse em uma melhor qualificação e aprimoramento profissional na área de atuação" },
            { id: 6, descricao: "Expansão das atividades profissionais para outros campos" },
            { id: 7, descricao: "Não se aplica (ensino, pesquisa e extensão)" },
            { id: 8, descricao: "Prefiro não responder" }
         ],
         atividadesContribuicoesOptions: [
            { id: 1, descricao: "Participou de eventos científicos" },
            { id: 2, descricao: "Publicou Livro(s) e/ou Capítulos de Livro(s)" },
            { id: 3, descricao: "Desenvolveu patente ou registro de software" },
            { id: 4, descricao: "Recebeu Prêmio científico ou profissional" },
            { id: 5, descricao: "Colaborou em Rede de Pesquisa" },
            { id: 6, descricao: "Contribuiu para Políticas e Práticas relevantes na área de formação" },
            { id: 7, descricao: "Não realizei nenhuma das atividades acima descritas" }
         ],
         impacto: [
            { valor: 1, nome: "Contribuiu substancialmente" },
            { valor: 2, nome: "Contribuiu moderadamente" },
            { valor: 3, nome: "Contribuiu pouco" },
            { valor: 4, nome: "Não contribuiu" }
         ],
         melhoria: [
            { valor: 1, nome: "Concordo totalmente" },
            { valor: 2, nome: "Concordo parcialmente" },
            { valor: 3, nome: "Não concordo nem discordo" },
            { valor: 4, nome: "Discordo parcialmente" },
            { valor: 5, nome: "Discordo totalmente" }
         ],
         setor: [
            { valor: 1, nome: "Empresário/autônomo/profissional liberal" },
            { valor: 2, nome: "Docente e/ou pesquisador de Instituição pública (Ensino apenas em graduação)" },
            { valor: 3, nome: "Docente e/ou pesquisador de Instituição pública (Ensino em graduação e pós-graduação)" },
            { valor: 4, nome: "Docente e/ou pesquisador de Instituição privada (Ensino apenas em graduação)" },
            { valor: 5, nome: "Docente e/ou pesquisador de Instituição privada (Ensino em graduação e pós-graduação)" },
            { valor: 6, nome: "Profissional de Instituição pública (exceto docência/pesquisa)" },
            { valor: 7, nome: "Profissional de Instituição privada (exceto docência/pesquisa)" },
            { valor: 8, nome: "Terceiro Setor (ONGs, organizações sem fins lucrativos)" },
            { valor: 9, nome: "Estagiário" }
         ],
         profileError: '',
         profileSuccess: '',
         formError: '',
         formSuccess: '',
         showEgressoModal: false,
      };
   },
   computed: {
      cursosFiltrados() {
         const nivel = this.nivelCursoMap[this.question.nivel];
         return this.cursos.filter(c => c.nivel === nivel);
      },
      // agrupadasPorTipo() {
      //    const grupos = {};
      //    if (this.lista && Array.isArray(this.lista)) {  // Verifica se 'lista' é válida
      //       this.lista.forEach(item => {
      //       if (item && item.tipo) {  // Verifica se o item e item.tipo são válidos
      //          if (!grupos[item.tipo]) {
      //             grupos[item.tipo] = [];
      //          }
      //          grupos[item.tipo].push(item);
      //       }
      //       });
      //    }
      //    return grupos;
      // }
   },
   methods: {
      carregavalores(v){
         this.question.nivel = v.tipo
         this.question.curso = v.nome_curso
         this.question.ano = v.ano_conclusao
         this.question.cotista = v.foi_cotista ? 'Sim' : 'Não'
         this.question.sistemaCotas = v.descricao_cota
         this.question.observacaoCotas = v.observacoes_cota
         this.question.bolsista = v.foi_bolsista
         this.question.agenciaFomentadora = v.agencia_fomentadora
         this.question.agenciaOutro = v.agencia_outro
         this.question.motivacoes = v.motivacoes
         this.question.participacaoCientifica = v.participacao_cientifica
         this.question.participacaoExtensao = v.participacao_extensao
         this.question.participacaoEnsino = v.participacao_ensino
         this.question.participacaoMonitoria = v.participacao_monitoria
         this.question.evaluation = v.avaliacaoItems
         this.question.observacoes = v.observacoes
         this.question.atividadesContribuicoes = v.atividades_contribuicoes
         this.question.impactoPesquisa = v.impacto_pesquisa
         this.question.melhoriaProcessos = v.melhoria_processos
         this.question.inovacaoEmpreendedorismo = v.inovacao_empreendedorismo
         this.question.startupNegocios = v.startup_negocios
         this.question.responsabilidadeSocial = v.responsabilidade_social
         this.question.atividadesResponsabilidade = v.atividades_responsabilidade
         this.question.vinculoEmpregaticio.mercado_trabalho_12_meses = v.vinculos_empregaticios[0].mercado_trabalho_12_meses
         this.question.vinculoEmpregaticio.situacao_atual = v.vinculos_empregaticios[0].situacao_atual
         this.question.vinculoEmpregaticio.setor_atuacao = v.vinculos_empregaticios[0].setor_atuacao
         this.question.vinculoEmpregaticio.jornada_trabalho = v.vinculos_empregaticios[0].jornada_trabalho
         this.question.vinculoEmpregaticio.instituicao_atual = v.vinculos_empregaticios[0].instituicao_atual
         this.question.vinculoEmpregaticio.salario_medio = v.vinculos_empregaticios[0].salario_medio
         this.question.vinculoEmpregaticio.impacto_renda = v.vinculos_empregaticios[0].impacto_renda
         this.question.vinculoEmpregaticio.qualificacao_mercado = v.vinculos_empregaticios[0].qualificacao_mercado
         this.question.posicao_gestao.ocupaPosicao = v.posicoes_gestao[0].ocupaPosicao
         this.question.posicao_gestao.detalhesPosicao = v.posicoes_gestao[0].detalhesPosicao
         this.question.formacaoid = v.id_formacao 
         this.formSuccess = ''
      },
      limpavalores(){
         this.question.formacaoid = 0
         this.question.nivel = ''
         this.question.curso = ''
         this.question.ano = ''
         this.question.cotista = ''
         this.question.sistemaCotas = ''
         this.question.observacaoCotas = ''
         this.question.bolsista = ''
         this.question.agenciaFomentadora = ''
         this.question.agenciaOutro = ''
         this.question.motivacoes = []
         this.question.participacaoCientifica = ''
         this.question.participacaoExtensao = ''
         this.question.participacaoEnsino = ''
         this.question.participacaoMonitoria = ''
         this.question.evaluation = Array(12).fill('')
         this.question.observacoes = ''
         this.question.atividadesContribuicoes = []
         this.question.impactoPesquisa = ''
         this.question.melhoriaProcessos = ''
         this.question.inovacaoEmpreendedorismo = ''
         this.question.startupNegocios = ''
         this.question.responsabilidadeSocial = ''
         this.question.atividadesResponsabilidade = ''
         this.question.vinculoEmpregaticio.mercado_trabalho_12_meses = ''
         this.question.vinculoEmpregaticio.situacao_atual = ''
         this.question.vinculoEmpregaticio.setor_atuacao = ''
         this.question.vinculoEmpregaticio.jornada_trabalho = ''
         this.question.vinculoEmpregaticio.instituicao_atual = ''
         this.question.vinculoEmpregaticio.salario_medio = ''
         this.question.vinculoEmpregaticio.impacto_renda = ''
         this.question.vinculoEmpregaticio.qualificacao_mercado = ''
         this.question.posicao_gestao.ocupaPosicao = ''
         this.question.posicao_gestao.detalhesPosicao = ''
         this.atualizar = false
      },
      async submitQuestionario() {
         this.formError = '';
         this.formSuccess = '';
         if (!this.validateAll()) return;
         await this.handleSubmit();
         this.limpavalores();
         window.history.replaceState(null, null, window.location.href); //limpar histórico de envio de formulario

         if (this.formSuccess) {
            this.showEgressoModal = false;
            this.carregaperfil();
         }
      },
      async updateProfile() {
         this.profileError = '';
         this.profileSuccess = '';
         if (!this.form.gender || !this.form.birthDate || !this.form.maritalStatus || !this.form.currentState || !this.form.originState || !this.lgpd) {
            this.profileError = 'Preencha todos os campos obrigatórios do perfil.';
            return;
         }

         const payload = {
            genero: this.form.gender,
            dataNascimento: this.form.birthDate,
            nacionalidade: this.form.nationality,
            pais: this.form.country,
            corRaca: this.form.race,
            deficiencia: this.form.disabled,
            tipoDeficiencia: this.form.disabilityDetail,
            estadoCivil: this.form.maritalStatus,
            estadoResidencia: this.form.currentState, 
            estadoOrigem: this.form.originState,
            lgpd: this.lgpd,
         };
         try {
            // Garante que o token ainda é válido
            await this.keycloak.updateToken(10);

            const response = await fetch(this.backend + '/perfil/', {
                  method: 'POST',
                  headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${this.keycloak.token}`,
                  },
                  body: JSON.stringify(payload),

                  credentials: 'include' // Inclui os cookies na requisição
            });
            if (!response.ok) throw new Error('Erro ao enviar');
            const result = await response.json();
            // atualiza
            //fetchData();
            console.log('Enviando questionário completo:', result);
         } catch (err) {
            console.error('Erro ao enviar:', err);
            alert('Falha ao enviar dados.');
         }

         //console.log('Enviando perfil:', this.form);
         this.profileSuccess = 'Perfil atualizado com sucesso.';
      },
      validateAll() {
         if (!this.question.bolsista) {
            this.formError = 'Informe se foi bolsista.';
            return false;
         }
         if (this.question.bolsista === 'Sim' && !this.question.agenciaFomentadora) {
            this.formError = 'Informe a agência fomentadora.';
            return false;
         }
         if (this.question.nivel === 'Graduação') {
            if (!this.question.participacaoCientifica) { this.formError = 'Informe participação científica.'; return false; }
            if (!this.question.participacaoExtensao) { this.formError = 'Informe participação em extensão.'; return false; }
            if (!this.question.participacaoEnsino) { this.formError = 'Informe participação em ensino.'; return false; }
            if (!this.question.participacaoMonitoria) { this.formError = 'Informe participação em monitoria.'; return false; }
         } else {
            if (this.question.motivacoes.length === 0) { this.formError = 'Informe ao menos uma motivação.'; return false; }
         }
         if (this.question.atividadesContribuicoes.length === 0) { this.formError = 'Informe atividades de contribuição.'; return false; }
         if (!this.question.impactoPesquisa) { this.formError = 'Informe impacto da pesquisa.'; return false; }
         if (!this.question.melhoriaProcessos) { this.formError = 'Informe melhoria de processos.'; return false; }
         if (!this.question.inovacaoEmpreendedorismo) { this.formError = 'Informe inovação/empreendedorismo.'; return false; }
         if (!this.question.responsabilidadeSocial) { this.formError = 'Informe responsabilidade social.'; return false; }
         if (this.question.responsabilidadeSocial.startsWith('Sim') && !this.question.atividadesResponsabilidade) { this.formError = 'Descreva atividades de responsabilidade social.'; return false; }
         if (this.question.evaluation.some(v => v === '')) { this.formError = 'Preencha todas as avaliações.'; return false; }
         const ve = this.question.vinculoEmpregaticio;
         if (!ve.mercado_trabalho_12_meses || !ve.situacao_atual || !ve.setor_atuacao || !ve.jornada_trabalho || !ve.instituicao_atual || !ve.salario_medio || !ve.qualificacao_mercado) {
            this.formError = 'Preencha todos os campos de empregabilidade.';
            return false;
         }
         if (!this.question.posicao_gestao.ocupaPosicao) { this.formError = 'Informe posição de gestão.'; return false; }
         return true;
      },
      async carregaperfil(){
         this.loading = true;
         this.error = null;
         try {
            const response = await fetch(this.backend + '/meusdados/', {
                  method: 'GET',
                  headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${this.keycloak.token}`,
                  }
            });
            if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();''
            this.lista = json.formacao;
            this.form.fullName = json.message.nome;
            this.form.cpf = json.message.cpf;
            this.form.gender = json.message.genero;
            this.form.birthDate = json.message.data_nascimento;
            this.form.nationality = json.message.nacionalidade;
            this.form.country = json.message.pais;
            this.form.race = json.message.cor_raca;
            this.form.disabled = json.message.deficiencia;
            this.form.disabilityDetail = json.message.tipo_deficiencia;
            this.form.maritalStatus = json.message.estado_civil;
            this.form.currentState = json.message.estado_residencia;
            this.form.originState = json.message.estado_origem;
            this.lgpd = json.message.lgpd;
         } catch (e) {
            this.error = e.message;
         } finally {
            this.loading = false;
         }
      },
      async handleSubmit() {
         this.formError = '';
         this.formSuccess = '';
         if (!this.validateAll()) return;
         const payload = {
            nivelConcluido: this.question.nivel,
            cursoNaUfdpar: this.question.curso,
            anoConclusao: this.question.ano,
            foiCotista: this.question.cotista,
            sistemaCotas: this.question.cotista === 'Sim' ? this.question.sistemaCotas : null,
            observacaoCotas: this.question.observacaoCotas,
            foiBolsista: this.question.bolsista,
            agenciaFomentadora: this.question.agenciaFomentadora,
            agenciaOutro: this.question.agenciaOutro,
            avaliacaoItems: this.question.evaluation, //this.evaluationItems.map((label, idx) => ({ label, value: this.question.evaluation[idx] })),
            observacoes: this.question.observacoes,
            atividadesContribuicoes: this.question.atividadesContribuicoes,
            impactoPesquisa: this.question.impactoPesquisa,
            melhoriaProcessos: this.question.melhoriaProcessos,
            inovacaoEmpreendedorismo: this.question.inovacaoEmpreendedorismo,
            startupNegocios: this.question.startupNegocios,
            responsabilidadeSocial: this.question.responsabilidadeSocial,
            atividadesResponsabilidade: this.question.atividadesResponsabilidade,
            vinculoEmpregaticio: this.question.vinculoEmpregaticio,
            posicao_gestao: this.question.posicao_gestao
         };
         if (this.question.nivel === 'Graduação'){
            payload.participacaoCientifica = this.question.participacaoCientifica;
            payload.participacaoExtensao = this.question.participacaoExtensao;
            payload.participacaoEnsino = this.question.participacaoEnsino;
            payload.participacaoMonitoria = this.question.participacaoMonitoria;
         } else {
            payload.motivacoes = this.question.motivacoes;
         }
         if(this.atualizar) payload.id_formacao = this.question.formacaoid;


         try {
            // Garante que o token ainda é válido
            await this.keycloak.updateToken(10);

            const response = await fetch(this.backend + '/formacao/', {
                  method: 'POST',
                  headers: {
                     'Content-Type': 'application/json',
                     'Authorization': `Bearer ${this.keycloak.token}`,
                  },
                  body: JSON.stringify(payload),

                  credentials: 'include' // Inclui os cookies na requisição
            });
            if (!response.ok) throw new Error('Erro ao enviar');
            const result = await response.json();
            // atualiza
            //fetchData();
            console.log('Enviando questionário completo:', result);
         } catch (err) {
            console.error('Erro ao enviar:', err);
            alert('Falha ao enviar dados.');
         }
         this.formSuccess = 'Questionário enviado com sucesso.';
      },
      mensagemExcluir(){
         this.formSuccess = 'Para excluir entre em contato com a PREG';
      }
   },
  mounted() {
    this.carregaperfil();
    this.form.fullName = this.keycloak.tokenParsed?.name;
    this.form.cpf = this.keycloak.tokenParsed?.cpf;
  },
};
</script>
<style scoped>
.modal-dialog-hero .modal-content {
   background: #ffffff;
   border: none;
   padding: 0;
}

.modal-custom {
   background: #ffffff;
   border-radius: 1rem;
   box-shadow: 0 25px 60px -10px rgba(0, 0, 0, 0.25);
   overflow: hidden;
   display: flex;
   flex-direction: column;
}

.modal-header {
   border-bottom: none;
}

.modal-body {
   max-height: 70vh;
   overflow-y: auto;
   background: #ffffff;
}

.modal-footer {
   background: #f1f3fa;
   border-top: none;
}
</style>
